export const GLOBAL = {
    API: {
        url: 'https://skyzone.gt/api-tripleaaa/api/'
    }
  };
  